module.exports = __webpack_public_path__ + "img/bl-pet-firendly.1c3af53c.png";